import { ComponentProps } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";
import { ServiceKind } from "@bitory-gmbh/bsm";
import { Filter } from "@/shared/lib/filter/filter";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { Label } from "@/services/backend/processes/api/state";
import { useProcessesProcessListQuery } from "@/services/backend/processes/api/process-api";
import { ProcessNumber } from "@/services/backend/numbers/components/process-number";
import { RefreshCw } from "lucide-react";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function ProcessSelect({
  serviceKindFilter = { active: false, values: [] },
  companyFilter = { active: false, values: [] },
  branchFilter = { active: false, values: [] },
  customerFilter = { active: false, values: [] },
  stateFilter = { active: false, values: [] },
  ...props
}: ComponentProps<typeof SelectPrimitive.Root> & {
  serviceKindFilter?: Filter<ServiceKind>;
  companyFilter?: Filter<string>;
  branchFilter?: Filter<string>;
  customerFilter?: Filter<string>;
  stateFilter?: Filter<Label>;
}) {
  const { data, isLoading, error } = useProcessesProcessListQuery({
    serviceKind: serviceKindFilter,
    company: companyFilter,
    branch: branchFilter,
    customer: customerFilter,
    state: stateFilter,
    orderBy: [{ field: "updatedAt" }],
  });

  return (
    <Select {...props}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Vorgang auswählen" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {error && (
            <RTKQueryErrorAlert error={error} ignoreValidationError={false} />
          )}
          {isLoading && (
            <SelectItem value="null" disabled>
              <RefreshCw className="animate-spin" /> Lade ...
            </SelectItem>
          )}
          {data && data.items.length === 0 && (
            <SelectItem value="null" disabled>
              {t("Keine Vorgänge gefunden")}
            </SelectItem>
          )}
          {data &&
            data.items.map((process) => (
              <SelectItem value={process.id} key={process.id}>
                <ProcessNumber processId={process.id} />
              </SelectItem>
            ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
